var _path, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50941 17.5C6.58252 15.6101 7.07829 14.4191 7.8772 13.6794C8.75243 12.869 10.0974 12.5 12 12.5C13.8777 12.5 15.2294 12.9516 16.114 13.8116C16.9197 14.595 17.4101 15.7876 17.4888 17.5H6.50941Z",
    stroke: "#407EDB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8.5,
    r: 2,
    stroke: "#407EDB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserProfile);
export default __webpack_public_path__ + "static/media/icon_user_profile.6b26cc6e5a3075ff61e12163205af653.svg";
export { ForwardRef as ReactComponent };